<template>
  <div>
    <el-upload
      :drag="listType == 'picture-card' ? true : false"
      :action="upLoadUrl"
      :list-type="listType"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :http-request="uploadSectionFile"
      :before-upload="handleBeforeUpload"
      :file-list="fileLists"
      :limit="limit"
      :disabled="disabled"
    >
      <div v-if="listType == 'picture-card'">
        <i class="el-icon-plus"></i>
        <!-- <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div> -->
      </div>
      <div v-if="listType == 'text'">
        <i class="el-icon-plus"></i>
        <!-- <el-button size="small">选择文件</el-button> -->
      </div>
    </el-upload>
    <el-dialog
      width="60%"
      close-on-click-modal
      :visible.sync="disShowImgs"
      append-to-body
    >
      <el-image
        class="imgColor"
        style="width: 100%; height: 70vh"
        fit="scale-down"
        :src="dialogImageUrl"
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>
import tools from "@/assets/js/tool";
export default {
  props: {
    fileNameLists: {
      type: Array,
      default: [],
    },
    limit: {
      type: Number,
      default: 1,
    },

    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    //照片墙类型
    listType: {
      type: String,
      default: "picture-card",
    },
    // 文件类型, 例如["doc", "xls", "ppt", "txt", "pdf"]
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg", "pdf"],
    },
  },
  data() {
    return {
      upLoadUrl: "", //上传地址
      dialogImageUrl: "",
      //   fileNameList: [],
      fileLists: [],
      disShowImgs: false,
      showBtns: true,
    };
  },
  watch: {
    fileNameLists: {
      immediate: true,
      handler: function (newVal, oldVa) {
        this.fileLists = newVal || [];
      },
      deep: true,
    },
  },
  created() {
    this.upLoadUrl = this.$COMMON.uploadUrl;
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.disShowImgs = true;
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList || [];
      this.changeFileList(this.fileLists);
    },
    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData(); //  根据后台需求数据格式
      form.append("file", file); //  文件对象
      form.append("fileName", fileName); //  本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      let sign = tools.getSign({ fileName: fileName });
      form.append("sign", sign);
      this.$showLoading();
      this.$API.uploadFile(form).then((res) => {
        this.$hideLoading();
        if (res.data.status === "success") {
          //   this.fileNameList.push(res.data.result.fileName);
          let obj = {
            name: res.data.result.fileName,
            url: res.data.result.url,
          };
          this.fileLists.push(obj);
          this.changeFileList(this.fileLists);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType && file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk & file) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize && file) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 文件列表改变的时候，更新组件的v-model的文的数据
    changeFileList(fileList) {
      // console.log("fileList");
      // console.log(fileList);
      // if (fileList.length >= this.limit) {
      //   this.showBtns = false;
      // }

      //   let tempFileList = [];
      //   fileList.forEach((item) => {
      //     tempFileList.push(item.fileName);
      //   });
      this.$emit("input", fileList);
    },
  },
};
</script>

<style scoped>
.imgColor {
  background: #f2f2f2;
}
</style>